import { socketUrl } from 'config';
import { useEffect, useState } from 'react';
import { io, Socket } from 'socket.io-client';

class SocketImpl {
  socket: null | Socket = null;
  accessToken = '';

  initialize(accessToken) {
    try {
      this.accessToken = accessToken;

      this.startSocket();

      this.socket?.on('connect_error', (err) => {
        // console.log(`connect_error due to ${err.message}`);
        // this.startSocket();
      });

      this.socket?.on('disconnect', () => {
        console.log(`socket disconnected`);
        // this.startSocket();
      });

      this.socket?.on('connect', () => {
        try {
          this.socket?.emit('init');
        } catch (err) {
          console.log('Socket hang up');
          this.startSocket();
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  startSocket() {
    this.socket = io(socketUrl, {
      path: '/socket.io',
      query: { token: this.accessToken },
    });
  }
}

export const socket = new SocketImpl();
// Object.freeze(socket);

export const useSocketComment = () => {
  const [comment, setComment] = useState(false);

  useEffect(() => {
    socket.socket?.on('comment', () => {
      setComment((prev) => !prev);
    });
  }, []);

  return comment;
};

export const useSocketNotification = () => {
  const [notification, setNotification] = useState(false);
  useEffect(() => {
    const notifCallback = () => {
      console.log('Received notification');
      setNotification((prev) => !prev);
    };

    socket.socket?.on('notification', notifCallback);

    return () => {
      socket.socket?.off('notification', notifCallback);
    };
  }, []);

  return notification;
};

export const useSocketSyncOrg = ({ organisation }) => {
  const [data, setData] = useState({});
  useEffect(() => {
    const notifCallback = (sync) => {
      setData({ sync });
    };

    socket.socket?.on(organisation, notifCallback);

    return () => {
      socket.socket?.off(organisation, notifCallback);
    };
  }, []);

  return data;
};

export const useSocketSyncUser = ({ user }) => {
  const [data, setData] = useState({ user, time: new Date() });

  useEffect(() => {
    const notifCallback = (user) => {
      setData({ user, time: new Date() });
    };

    socket.socket?.on(user, notifCallback);

    return () => {
      socket.socket?.off(user, notifCallback);
    };
  }, []);

  return data;
};

export const useSocketSyncMember = ({ member }) => {
  const [data, setData] = useState({ member, time: new Date() });

  useEffect(() => {
    const notifCallback = (member) => {
      setData({ member, time: new Date() });
    };

    socket.socket?.on(member, notifCallback);

    return () => {
      socket.socket?.off(member, notifCallback);
    };
  }, []);

  return data;
};

export const useSocketSyncShared = ({ type, id }) => {
  const [data, setData] = useState({ type, id, time: new Date() });

  useEffect(() => {
    const notifCallback = ({ type, id }) => {
      setData({ type, id, time: new Date() });
    };

    socket.socket?.on(id, notifCallback);
  }, []);

  return data;
};

export const useSocketSyncItem = ({ item }) => {
  const [data, setData] = useState({ item, time: new Date() });

  useEffect(() => {
    const notifCallback = (item) => {
      setData({ item, time: new Date() });
    };

    socket.socket?.on(item, notifCallback);

    return () => {
      socket.socket?.off(item, notifCallback);
    };
  }, []);

  return data;
};
